import React, { Component }      from 'react';
import { UrlShortenerConstants } from './environment';
import { isInRoleFromToken }     from '../../../utils/authService';

class UrlShortenerBreadcrumb extends Component {

  render() {
    if (isInRoleFromToken(UrlShortenerConstants.AdminRole)) {
      return (
        <div style={{marginLeft: '10%'}} className="c-breadcrumbs__wrapper" >
          <ul style={{ marginLeft: '20px', marginRight: '20px' }} className="c-breadcrumbs">
            <li className="c-breadcrumbs__item">
              <a href={UrlShortenerConstants.AdminHashPrefix + '/list'} className="anchor c-breadcrumbs__anchor" >
                List
              </a>
            </li>
          </ul>
        </div>
      );
    }
    else if (isInRoleFromToken(UrlShortenerConstants.UserRole)) {
      
    }
    else {
      // Not logged in or wrong role
    }
  }
}

export default UrlShortenerBreadcrumb;